// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
const vuetify = createVuetify({
  components,
  directives,
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1600,
    },
  },
  defaults: {
    VBtn: {
      style: { textTransform: "none" },
    },
    typography: {
      defaultFontFamily: "Inter",
    },
  },
});
export default vuetify;
